<template>
	<ui-modal :load="load" title="Copiar código do Chat" icon="fal fa-code" name="marketing-queues-chat-code" size="xs">
		<div class="modal">
			<div class="title">Cole o código abaixo em seu site dentro da tag <strong>Head</strong>.</div>
			<ui-code :copy="doCopy">&lt;script&gt;{{ script }}&lt;/script&gt;</ui-code>
		</div>

		<template #footer>
			<div class="buttons">
				<ui-button design="link lg" @click="cancel">Cancelar</ui-button>
				<ui-button design="lg primary" @click="copyCode">Copiar Código</ui-button>
			</div>
		</template>
	</ui-modal>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiModal } from '@/components/ui/modal'
	import { uiCode } from '@/components/ui'

	import { tokens } from '@/services/axios'
	import { storage } from '@/services/storage'

	import helpers from '@/mixins/helpers'

	export default {
		components: {
			uiModal,
			uiButton,
			uiCode,
		},

		mixins: [helpers],

		data() {
			return {
				id: null,
				name: null,
				token: null,
				userToken: null,
				apiConfig: JSON.parse(storage.get('api_config')),
				load: false,
				doCopy: false,
			}
		},

		computed: {
			script() {
				if (!this.token && !this.userToken) return '...'

				return `
							!function(){window;var t=document,e=t.createElement("script"),a="https://cdn.appfacilita.com/static/facilita-chat/",c="_assets/_js/";e.type="text/javascript",e.id="facilita-chat-widget",e.src=a+c+"widget.js";var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(e,i);var s=t.createElement("script");s.type="text/javascript",s.id="facilita-chat-storage",s.async=!0,s.src=a+c+"storage.js";var r=t.getElementsByTagName("script")[1];r.parentNode.insertBefore(s,r)}();
							function facilitaChatAction(e){var t="facilita-chat-storage",o=sessionStorage.getItem(t);(o=JSON.parse(o)).open;function a(e){var t={action:e};document.getElementById("chat-iframe-button").contentWindow.postMessage(t,"*"),window.postMessage(t,"*")}switch(e){case"open":a("open");break;case"close":a("close");break;case"toggle":a("toggle")}sessionStorage.setItem(t,JSON.stringify(o))}
							facilitaSettings={instancia:"${this.apiConfig.instance}",queue:"${this.id}",local:!1,source:"${this.name}",gstoken:"${this.token}",open:!0,gstokenUser:"${this.userToken}"};

							// se você deseja iniciar o chat fechado na primeira vez que o usuário entra no site altere o parametro open para false
							// você pode abrir e fechar a janela do chat chamando a função facilitaChatAction() no evento onClick do elemento
							// a função facilitaChatAction() aceita 3 parâmetros. toggle, open, close
							// exemplo: <button type="button" id="abrir" onclick="facilitaChatAction('toggle')">Abrir e fechar chat</button>
						`
			},
		},

		methods: {
			cancel() {
				this.$children[0].close()
			},

			copyCode() {
				this.doCopy = true
				
				setTimeout(() => {
                    this.doCopy = false
                }, 3000)
			},
		},

		mounted() {
			this.$root.$on('modal-open-marketing-queues-chat-code', (data) => {
				this.load = true
				this.id = data.id
				this.name = data.name

				tokens
					.chat()
					.then((response) => {
						if (response.data && response.data.msg) {
							this.$toastr.e(response.data.msg)
						} else {
							this.userToken = response.data.token_user
							this.token = response.data.token_platform
						}
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.load = false
					})
			})
		},

		beforeDestroy(){
			this.$root.$off('marketing-queues-call-tracking-search')
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
